import { IWebchatChatSessionsRepository } from 'modules/webchat/domain/repositories';
import { makeStorageProvider } from 'shared/infra/providers';

import LocalStorageWebchatChatSessionsRepository from './implementations/LocalStorageWebchatChatSessionsRepository';

let instance: IWebchatChatSessionsRepository | null = null;

export default function makeWebchatChatSessionsRepository() {
  if (!instance) {
    instance = new LocalStorageWebchatChatSessionsRepository(
      makeStorageProvider(),
    );
  }

  return instance;
}
